/**
 * @generated SignedSource<<a94147a40958c942233d08b59f52b3ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type workItemsTable_AtlassianConversationAssistantPreviewCard_project$data = {
  readonly issueTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly issueTypeId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_issueType">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_project">;
  readonly " $fragmentType": "workItemsTable_AtlassianConversationAssistantPreviewCard_project";
};
export type workItemsTable_AtlassianConversationAssistantPreviewCard_project$key = {
  readonly " $data"?: workItemsTable_AtlassianConversationAssistantPreviewCard_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"workItemsTable_AtlassianConversationAssistantPreviewCard_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_project",
  "selections": [
    {
      "concreteType": "JiraIssueTypeConnection",
      "kind": "LinkedField",
      "name": "issueTypes",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "issueTypeId"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_issueType"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "workItemsTable_AtlassianConversationAssistantPreviewCard_RowWithWrapper_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "6cf7587a93e258bda6babd41521d0231";

export default node;
